import React, { useState, useEffect } from "react";
import { ArrowRight, CircleCheck, ThermometerSnowflake, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MasteryInClimateControl() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [videoLoaded, setVideoLoaded] = useState(false);
  const businessName = "Exergy Systems";
  const serviceLink = "/ExergyAuditPage";
  const fieldWorkLink = "/TechnicalSolutionPage";
  return <section data-section-id="33239" id="autonomic-energy-intelligence" className="dark bg-[#0A0A0B] text-[#F5F5F7] relative min-h-[90vh] flex items-center overflow-hidden py-20">
      {}
      <div className="absolute inset-0 z-0">
        <div className={`absolute inset-0 bg-[#0A0A0B]/80 z-10 transition-opacity duration-1000 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`} />
        {}
        <div className="absolute inset-0 bg-[#0A0A0B] z-0" style={{
        backgroundImage: `linear-gradient(to right, #2A2A2E 1px, transparent 1px), linear-gradient(to bottom, #2A2A2E 1px, transparent 1px)`,
        backgroundSize: '50px 50px'
      }} />
        
        <video autoPlay loop muted playsInline onLoadedData={() => setVideoLoaded(true)} className="absolute inset-0 w-full h-full object-cover opacity-30 grayscale contrast-125" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/hero_poster_frost.png">
          <source src="/videos/frost_coil_loop.mp4" type="video/mp4" />
        </video>
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 md:px-6 grid lg:grid-cols-12 gap-12 items-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="lg:col-span-8 flex flex-col gap-8">
          <h1 className="text-[12vw] lg:text-[7vw] font-bold leading-[0.9] tracking-wider text-transparent bg-clip-text bg-gradient-to-b from-[#F5F5F7] via-[#F5F5F7]/90 to-[#A1A1AA] drop-shadow-sm uppercase">
            ELIMINATE <br />
            THERMAL <br />
            WASTE.
          </h1>
          
          <p className="text-sm md:text-lg text-[#39FF14] max-w-2xl font-mono leading-relaxed border-l border-[#39FF14]/50 pl-6 uppercase tracking-widest">
            STATUS: OPTIMIZING GRID_ALPHA... RECLAIMING LOST POWER THROUGH AUTONOMIC THERMAL INTELLIGENCE. SURGICAL EFFICIENCY FOR DATA CENTERS AND INDUSTRIAL INFRASTRUCTURE.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-4">
            <Button asChild size="lg" className="h-14 px-8 text-lg bg-[#39FF14] hover:bg-[#39FF14]/80 text-[#0A0A0B] shadow-[0_0_15px_rgba(57,255,20,0.3)] border-0 rounded-none skew-x-[-10deg] font-mono font-bold">
              <Link to={serviceLink}>
                <span className="skew-x-[10deg] flex items-center gap-2">
                  INITIATE AUDIT <ArrowRight className="w-5 h-5" />
                </span>
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg border-[#2A2A2E] text-[#F5F5F7] hover:bg-[#F5F5F7]/5 hover:text-[#39FF14] hover:border-[#39FF14] rounded-none skew-x-[-10deg] backdrop-blur-sm font-mono">
              <Link to={fieldWorkLink}>
                <span className="skew-x-[10deg] flex items-center gap-2">
                  TECHNICAL SOLUTION <ThermometerSnowflake className="w-5 h-5" />
                </span>
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="lg:col-span-4 flex justify-center lg:justify-end perspective-1000">
          <div className="relative group animate-float">
            {}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#39FF14] to-transparent rounded-none blur opacity-10 group-hover:opacity-30 transition duration-1000"></div>
            
            <Card className="relative w-full max-w-sm bg-[#0A0A0B]/60 backdrop-blur-2xl border-[#2A2A2E] shadow-none overflow-hidden transform transition-transform hover:scale-[1.01] duration-500 rounded-none">
              <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-[#39FF14] to-transparent opacity-50"></div>
              
              <CardContent className="p-6 space-y-6">
                <div className="flex items-center justify-between border-b border-[#2A2A2E] pb-4">
                  <div className="flex items-center gap-3">
                    <div className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#39FF14] opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-[#39FF14]"></span>
                    </div>
                    <span className="text-[10px] font-mono text-[#39FF14] tracking-[0.2em] uppercase">System Active</span>
                  </div>
                  <Activity className="w-4 h-4 text-[#39FF14]/60" />
                </div>

                <div className="space-y-2">
                  <h3 className="text-[#F5F5F7] text-xs font-mono tracking-widest uppercase">Exergy_Recovery_Node</h3>
                  <div className="flex items-center gap-2">
                    <Badge variant="outline" className="bg-[#39FF14]/5 text-[#39FF14] border-[#39FF14]/20 px-3 py-0.5 rounded-none font-mono text-[10px]">
                      GRID_OPTIMIZED
                    </Badge>
                    <span className="text-[10px] font-mono text-[#A1A1AA]">LOAD: 98.4%</span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-2">
                  <div className="bg-[#F5F5F7]/5 rounded-none p-3 border border-[#2A2A2E]">
                    <div className="text-[10px] font-mono text-[#A1A1AA] mb-1 uppercase">Thermal Flux</div>
                    <div className="text-lg font-mono font-bold text-[#F5F5F7] tracking-tighter">STABLE</div>
                  </div>
                  <div className="bg-[#F5F5F7]/5 rounded-none p-3 border border-[#2A2A2E]">
                    <div className="text-[10px] font-mono text-[#A1A1AA] mb-1 uppercase">AI Core</div>
                    <div className="text-lg font-mono font-bold text-[#F5F5F7] tracking-tighter">LEARNING</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 text-[10px] font-mono text-[#A1A1AA] pt-2 border-t border-[#2A2A2E]">
                  <CircleCheck className="w-3 h-3 text-[#39FF14]" />
                  <span className="uppercase tracking-wider">Telemetry Link Secured</span>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#0A0A0B] to-transparent z-10 pointer-events-none"></div>
      
      {}
      <style jsx global>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotateX(0deg); }
          50% { transform: translateY(-10px) rotateX(1deg); }
        }
        .animate-float {
          animation: float 8s ease-in-out infinite;
        }
      `}</style>
    </section>;
}